import { Building2, LayoutGrid } from "lucide-react";

/** iter381 pt 5 — « 2 blocs | 88 lots » : chiffres 14/500 #E8E8EC, unités 11 #8A8A96, séparateur dégradé 1×14. */
export const BlocksLotsValue = ({ blocks, lots }) => (
  <span className="inline-flex items-center" style={{ gap: 6 }} data-testid="blocks-lots-value">
    <Building2 size={15} style={{ color: "#5B5FC7" }} /><span className="tabular-nums" style={{ fontSize: 14, fontWeight: 500, color: "#E8E8EC" }}>{blocks ?? "—"}</span><span style={{ fontSize: 11, color: "#8A8A96" }}>blocs</span>
    <span style={{ width: 1, height: 14, margin: "0 6px", background: "linear-gradient(to bottom, transparent, rgba(255,255,255,0.14), transparent)" }} />
    <LayoutGrid size={15} style={{ color: "#2A9A7A" }} /><span className="tabular-nums" style={{ fontSize: 14, fontWeight: 500, color: "#E8E8EC" }}>{lots ?? "—"}</span><span style={{ fontSize: 11, color: "#8A8A96" }}>lots</span>
  </span>
);
